export default __webpack_public_path__ + "media/images/icons/iphone-12512d7e9ab13c6f9c5161b6a5ae1334.png";